<template>
  <div class="card kit-data kit-risks card-shrink">
        <div class="header-item btn-back" @click="$emit('back')"><font-awesome-icon style="margin-right: 10px;" :icon="['fa', 'arrow-left']"/>
          <span class="desktop">Voltar</span>
        </div>
        <div class="rsl-header">
            <div class="header-item" v-if="result.kit_type_id > 2" @click="$emit('changeView', 'rsl')">
              <span class="item-text">Resultados</span>
            </div>
            <div class="header-item active" v-if="result.kit_type_id > 2" @click="$emit('changeView', 'rsk')">
              <span class="item-text">Riscos</span>
            </div>
            <div class="header-item" @click="$emit('download', result.id, result.exam.lab_document_id)">
              <font-awesome-icon class="desktop" style="margin-right: 5%;" :icon="['fa', 'receipt']" /> Laudo
            </div>
            <!-- <button class="button btn-primary btn-min" v-if="result.kit_type_id > 2" @click="$emit('changeView', 'pln')">Plano de cuidados</button>
            <button class="button btn-primary btn-min" @click="$emit('changeView', 'tps')">Dicas</button> -->
        </div>
    <div class="content-desktop">
      <span class="title">Riscos de Saúde</span>
      <div style="width: 100%;">
        <div>
          <div @click="openPanel">
              <div class="btn-expand">
                <h2 style="margin-right: 15px; margin-bottom: 0;"> {{this.result.kit_type.name}} </h2>
                <font-awesome-icon class='btn-svg icon-info' :icon="['fa', 'info-circle']" />
              </div>
          </div>
          <transition mode="out-in" name="slide-fade">
            <div class="panel-info" v-if="firstPanel">
              Quando você precisa realizar Check-up Saúde, o normal é você ir ao médico (a) e responder algumas
              perguntas; realizar os exames que ele (a) solicitar; e depois retornar para que ela (e) possa avaliar os
              seus exames. O médico (a), por sua vez, analisa o seu histórico, hábitos de vida e exames para chegar a
              determinados diagnósticos, promovendo os tratamentos e orientações adequadas.
              <br><br>
              <span class="font-weight-bold">Os nossos check-ups reproduzem essa rotina</span>, todavia, utilizando
              tecnologia e cruzando dados referentes aos seus hábitos de vida, exames físicos como pressão e
              circunferência abdominal, além de exames laboratoriais.
              <br><br>
              Com base em todos estes dados, <span class="font-weight-bold">aplicamos algoritmos médicos mundialmente reconhecidos e inteligência artificial</span>
              para obter riscos precisos sobre a sua saúde. Importante destacar que não realizamos nenhum diagnóstico.
              Nossa tecnologia é totalmente pautada em Medicina Preditiva/Preventiva e indica riscos à saúde. Ajudamos
              você a ter mais saúde, qualidade de vida e estar sempre na melhor versão.
              <br><br>
            </div>
          </transition>
        </div>
        <div class="panel-info" style="margin-bottom: 18px;" >
          Clique nos botões de <font-awesome-icon class='btn-svg' :icon="['fa', 'plus-circle']"/> situados no avatar para acessar os riscos e fatores preliminares calculados para você.
        </div>
        <div class="avatar-and-risks">
          <risk-avatar
            v-if="responsiveAvatar()"
            @changeRisk="changeRisks"
            :currentRisk="currentRisks"
            :kitTypeId="result.kit_type_id"
            :customer="result.customer"
            :answers="result.field_answers"
            :showHead="(headItems.risks.length > 0 || headItems.factors.length > 0)"
            :showTorso="(torsoItems.risks.length > 0 || torsoItems.factors.length > 0)"
            :showAbdomen="(abdomenItems.diagnostics.length > 0 || abdomenItems.risks.length > 0 || abdomenItems.factors.length > 0)"
            :showPelvis="(pelvisItems.risks.length > 0 || pelvisItems.factors.length > 0)"
            :showLeg="false && (legItems.risks.length > 3 || legItems.factors.length > 3)"
            :showOut="(outItems.risks.length > 0 || outItems.factors.length > 0)"
          />
          <risks-card
            v-if="currentRisks === 1"
            id="head-risks" 
            class="opeen"
            @close="changeRisks(0)"
            @openRisk="openModal"
            :risks="headItems.risks"
            :factors="headItems.factors"
          />
          <risks-card
            v-if="currentRisks === 2"
            id="torso-risks" 
            @close="changeRisks(0)"
            @openRisk="openModal"
            :risks="torsoItems.risks"
            :factors="torsoItems.factors"
          />
          <risks-card
            v-if="currentRisks === 3"
            id="abdomen-risks" 
            @close="changeRisks(0)"
            @openRisk="openModal"
            :diagnostics="abdomenItems.diagnostics"
            :risks="abdomenItems.risks"
            :factors="abdomenItems.factors"
          />
          <risks-card
            v-if="currentRisks === 4"
            id="pelvis-risks" 
            @close="changeRisks(0)"
            @openRisk="openModal"
            :risks="pelvisItems.risks"
            :factors="pelvisItems.factors"
          />
          <risks-card
            v-if="currentRisks === 5"
            id="leg-risks" 
            @close="changeRisks(0)"
            @openRisk="openModal"
            :risks="legItems.risks"
            :factors="legItems.factors"
          />
          <risks-card
            v-if="currentRisks === 6"
            id="out-risks" 
            @close="changeRisks(0)"
            @openRisk="openModal"
            :risks="outItems.risks"
            :factors="outItems.factors"
          />
        </div>
      </div>
    </div>
    <div class="content-mobile"></div>
    <loading-screen v-if="loading"/>
    <kit-risks-details
      :answers="formAnswers"
      :customer="result.customer"
      :result="result.exam.result"
      :risk="riskModal"
      @close="openModal(false, null, null)"
      v-if="riskModalOpen"/>
  </div>
</template>
<script>
import {GET_KIT_ANSWERS} from '../../services/kit';
import RiskModal from './RiskModal';
import KitRisksDetails from '../KitRisksDetails/KitRisksDetails.vue';

import {library} from '@fortawesome/fontawesome-svg-core';
import {faCircle, faMinusCircle, faInfoCircle, faReceipt} from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import RiskAvatar from '../RiskAvatar/RiskAvatar.vue';
import RisksCard from '../RisksCard/RisksCard.vue';

library.add(faMinusCircle);
library.add(faCircle);
library.add(faInfoCircle);
library.add(faReceipt);

export default {
  name: "kit-risks",
  components: { RiskModal, KitRisksDetails, RiskAvatar, RisksCard },
  props: {
    result: Object,
  },
  data() {
    return {
      firstPanel: false,
      secondPanel: false,
      thirdPanel: false,
      fourthPanel: false,
      loading: false,
      metrics: null,
      currentRisks: 0,
      diagnostics: [],
      risks: [],
      factors: [],
      headItems: {
        risks: [],
        factors: []
      },
      torsoItems: {
        risks: [],
        factors: []
      },
      abdomenItems: {
        diagnostics: [],
        risks: [],
        factors: []
      },
      pelvisItems: {
        risks: [],
        factors: []
      },
      legItems: {
        risks: [],
        factors: []
      },
      outItems: {
        risks: [],
        factors: []
      },
      formAnswers: [],
      riskModal: {},
      riskModalOpen: false,
      prevention: [],
      hasHeartDisease: false,
      hasDiabetes: false,
      hasHypertension: false,
      hasAvc: false,
      hasDyslipidimia: false,
      hasMetabolic: false,
      hasOsteoporosis: false,
    };
  },
  methods: {
    back() {
      this.$emit('back');
    },
    async loadKit(kit_id) {
      try {
        this.loading = true;
        const data = await GET_KIT_ANSWERS(kit_id);
        this.metrics = data.metric;
        this.formAnswers = data.field_answers;
        this.formAnswers.filter((a) => {
          return a.field.id == 'afaf2530-c963-4907-a519-9e2eef07bddc';
        });
        if (this.formAnswers.length > 0) {
          this.hasHeartDisease = this.answerSearch('Você é portador de alguma doença do coração?') == 'Sim' ? true : false;
          this.hasDiabetes = ['Sim, Descontrolada', 'Sim, Controlada'].includes(this.answerSearch('Você é portador de Diabetes?'));
          this.hasHypertension = this.answerSearch('Você é portador de Hipertensão?') != 'Não' ? true : false;
          this.hasAvc = this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes('avc') ? true : false;
          this.hasDyslipidimia = this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes('dislipidemia') ? true : false;
          this.hasOsteoporosis = this.answerSearch("Você é portador de quais doenças ou condições abaixo?", true).includes('Osteoporose') ? true : false;
        }

      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    openPanel() {
      let mobile = window.screen.width <= 1000;
      if(mobile) {
        this.firstPanel = !this.firstPanel
      }
    },
    openModal(open = true, title = null, altTitle = null, risk = null) {
		if (!!open && !!title) {
			this.riskModalOpen = open;
			this.riskModal = {
			title: title,
			altTitle: altTitle,
			risk: risk
			}
		} else if (!open) {
			this.riskModalOpen = open;
		}
    },
    changeRisks(risk) {
      this.currentRisks = (this.currentRisks == risk) ? 0 : risk;
    },
    responsiveAvatar() {
      let mobile = window.screen.width <= 1200;
      if(this.currentRisks != 0 && mobile) return false;
      return true;
    },
    getDotColor(label) {
		switch (label) {
			case 'indeferido':
			case 'Baixo':
			case 'Não detectado':
			return 'dot-green';
			case 'Médio':
			case 'Médio baixo':
			return 'dot-yellow';
			case 'Médio alto':
			case 'Alto':
			case 'Detectado':
			return 'dot-red';
			default:
			return 'dot-green';
		}
    },

    getUserExams() {
      let userGender = this.result.customer.gender;
      let userAge = this.result.customer.age;
      if (userGender == 'M') {
        if (userAge >= 40) {
          this.addPrevention('colesterol, triglicerídeos e glicose', '6');
          this.addPrevention('prostata', '12');
          this.addPrevention('ecocardiograma / raio-x do tórax e ultrasom do coração', '12');
          this.addPrevention('colonoscopia', '12');
        } else {
          this.addPrevention('colesterol, triglicerídeos e glicose', '12');
        }
      } else if (userGender == 'F') {
        if (userAge >= 40) {
          this.addPrevention('colesterol, triglicerídeos e glicose', '6');
          this.addPrevention('mamografia', '12');
          this.addPrevention('densiometria óssea', '24');
          this.addPrevention('papanicolau', '12');
          this.addPrevention('ecocardiograma / raio-x do tórax e ultrasom do coração', '12');
          this.addPrevention('colonoscopia', '12');
        } else {
          this.addPrevention('colesterol, triglicerídeos e glicose', '12');
          this.addPrevention('mamografia', '12');
          this.addPrevention('papanicolau', '12');
        }
      }

      if (this.hasHeartDisease) {
        this.addPrevention('cardiologista', '6');
        this.addPrevention('nutricionista', '25');
      }
      if (this.hasDiabetes) {
        this.addPrevention('endocrinologista', '3');
        this.addPrevention('nutricionista', '25');
      }
      if (this.hasHypertension) {
        this.addPrevention('cardiologista', '3');
        this.addPrevention('nutricionista', '25');
      }
      if (this.hasAvc) {
        this.addPrevention('neurologista', '6');
        this.addPrevention('cardiologista', '6');
        this.addPrevention('nutricionista', '25');
      }
      if (this.hasDyslipidimia) {
        this.addPrevention('cardiologista', '6');
        this.addPrevention('endocrinologista', '6');
        this.addPrevention('nutricionista', '25');
      }
      if (this.hasMetabolic) {
        this.addPrevention('endocrinologista', '6');
        this.addPrevention('cardiologista', '6');
        this.addPrevention('nutricionista', '25');
      }
      if (this.hasOsteoporosis) {
        this.addPrevention('reumatologista', '6');
        this.addPrevention('ortopedista', '6');
        this.addPrevention('ginecologista', '12');
        this.addPrevention('nutricionista', '25');
      }

      if (
        !this.hasHeartDisease &&
        !this.hasDiabetes &&
        !this.hasHypertension &&
        !this.hasAvc &&
        !this.hasDyslipidimia &&
        !this.hasMetabolic &&
        !this.hasOsteoporosis
      )
        this.addPrevention('clinico geral', '12');

    },
    addPrevention(exam, period) {
      let insert = true;
      this.prevention.map((ex, x) => {
        if (ex.includes(exam) && x <= period) {
          insert = false
        } else if (ex.includes(exam) && x > period) {
          this.prevention[x].map((a, y) => {
            if (a == exam)
              this.prevention[x].splice(y, 1);
          })
        }
      });
      if (insert)
        this.prevention[period].push(exam);
    },
    answerSearch(field, multiple = false, answers = []) {
      let ans = null;
      if (multiple) {
        if (answers.length > 0) {
          ans = this.formAnswers.filter(a => {
            return a.field.title == field && answers.includes(a.option.value);
          }).map(a => {
            return a.option.value;
          });
          return ans.join(', ');
        } else {
          ans = this.formAnswers.filter(a => {
            return a.field.title == field;
          }).map(a => {
            return a.option.value;
          });
          return ans;
        }
      } else {
        this.formAnswers.map(answer => {
          if (answer.field.title == field && !multiple)
            ans = answer.response !== null ? answer.response : answer.option.label;
        });
      }
      return ans;
    },
  },
  async mounted() {
    await this.loadKit(this.result.id);

    this.diagnostics = [];
    this.risks = [];
    this.factors = [];

    const treatMetrics = {}
    const _self = this;

    treatMetrics['Diagnostico Preliminar de Diabetes Mellitus'] = {
      validate(param) {
        return !param.hasDiabetes
      },
      code: 'diagnostico_diabetes',
      name: 'Diagnostico Preliminar de Diabetes Mellitus',
      label: 'indeferido',
      color: 'black',
      type: 'diagnostics',
      location: 'abdomen',
      setLabel: function (newLabel) {
        this.label = newLabel;
        this.color = _self.getDotColor(this.label)
      }
    }

    treatMetrics['Risco Internação'] = {
        validate(param) {
          return ( param.result.kit_type.tag_type == "check-up-saude-do-coracao"
                   || param.result.kit_type.tag_type == "check-up-longevidade-saudavel"
                   || param.result.kit_type.tag_type == "check-up-saude-preventiva" )
        },
        code: 'risco_internacao',
        title: 'Internação',
        altTitle: 'internacao',
        name: 'Risco Internação',
        label: 'indeferido',
        color: 'black',
        type: 'risks',
        location: 'out',
        setLabel: function (newLabel) {
          this.label = newLabel
          this.color = _self.getDotColor(this.label)
        }
    }

    treatMetrics['Risco Cardiovascular'] = {
      validate(param) {
        return ( param.result.kit_type.tag_type == "check-up-saude-do-coracao"
                 || param.result.kit_type.tag_type == "check-up-doencas-cronicas"
                 || (param.result.kit_type.tag_type == "check-up-saude-preventiva" && !param.hasHeartDisease) )
      },
      code: 'risco_cardiovascular',
      title: 'Risco Cardiovascular',
      altTitle: 'cardiovascular',
      name: 'Risco Cardiovascular',
      label: 'indeferido',
      color: 'black',
      type: 'risks',
      location: 'torso',
      setLabel: function (newLabel) {
        this.label = newLabel
        this.color = _self.getDotColor(this.label)
      }
    }

    treatMetrics['Risco Psicológico'] = {
      validate(param) {
        return ( param.result.kit_type.tag_type == "check-up-doencas-cronicas"
                 || param.result.kit_type.tag_type == "check-up-longevidade-saudavel"
                 || param.result.kit_type.tag_type == "check-up-saude-preventiva" )
      },
      code: 'risco_psicologico',
      title: 'Psicológico',
      altTitle: 'psicologico',
      name: 'Risco Psicológico',
      label: 'indeferido',
      color: 'black',
      type: 'risks',
      location: 'head',
      setLabel: function (newLabel) {
        this.label = newLabel
        this.color = _self.getDotColor(this.label)
      }
    }

    treatMetrics['Risco Fragilidade'] = {
		validate(param) {
			return ( param.result.kit_type.tag_type == "check-up-doencas-cronicas"
					|| param.result.kit_type.tag_type == "check-up-longevidade-saudavel" )
		},
		code: 'risco_fragilidade',
		title: 'Fragilidade',
		altTitle: 'fragilidade',
		name: 'Risco Fragilidade',
		label: 'indeferido',
		color: 'black',
		type: 'risks',
    location: 'out',
		setLabel: function (newLabel) {
			this.label = newLabel
			this.color = _self.getDotColor(this.label)
		}
    }

    treatMetrics['Risco de Lesão Muscular'] = {
      validate(param) {
        return ( param.result.kit_type.tag_type == "check-up-doencas-cronicas"
                || param.result.kit_type.tag_type == "check-up-longevidade-saudavel"
                || param.result.kit_type.tag_type == "check-up-saude-preventiva" )
      },
      code: 'risco_muscular',
      title: 'Lesão Muscular',
      altTitle: 'muscular',
      name: 'Fatores Preliminares para Desenvolver Lesão Muscular',
      label: 'indeferido',
      color: 'black',
      type: 'factors',
      location: 'leg',
      setLabel: function (newLabel) {
        this.label = newLabel
        this.color = _self.getDotColor(this.label)
      }
    }

    treatMetrics['Risco de desenvolver Hipertensão'] = {
      validate(param) {
        return ( param.result.kit_type.tag_type == "check-up-doencas-cronicas"
                 || param.result.kit_type.tag_type == "check-up-longevidade-saudavel"
                 || (param.result.kit_type.tag_type == "check-up-saude-preventiva" && !param.hasHypertension))
            && !param.hasHypertension
      },
      code: 'risco_hipertensao',
      title: 'Hipertensão',
      altTitle: 'hipertensao',
      name: 'Fatores Preliminares para Desenvolver Hipertensão',
      label: 'indeferido',
      color: 'black',
      type: 'factors',
      location: 'torso',
      setLabel: function (newLabel) {
        this.label = newLabel
        this.color = _self.getDotColor(this.label)
      }
    }

    treatMetrics['Risco de desenvolver Diabetes'] = {
      validate(param) {
        return ( param.result.kit_type.tag_type == "check-up-doencas-cronicas"
                 || param.result.kit_type.tag_type == "check-up-longevidade-saudavel"
                 || (param.result.kit_type.tag_type == "check-up-saude-preventiva" && !param.hasDiabetes) )
            && !param.hasDiabetes && param.result.exam.result.hba1c < 6.5
      },
      code: 'risco_diabetes',
      title: 'Diabetes',
      altTitle: 'diabetes',
      name: 'Fatores Preliminares para Desenvolver Diabetes',
      label: 'indeferido',
      color: 'black',
      type: 'factors',
      location: 'abdomen',
      setLabel: function (newLabel) {
        this.label = newLabel
        this.color = _self.getDotColor(this.label)
      }
    }

    treatMetrics['Risco de sofrer AVC'] = {
      validate(param) {
        return (param.result.kit_type.tag_type == "check-up-saude-do-coracao" || param.result.kit_type.tag_type == "check-up-saude-preventiva")
      },
      code: 'avc',
      title: 'Acidente Vascular Cerebral (AVC)',
      altTitle: 'avc',
      name: 'Fatores Preliminares para Desenvolver AVC',
      label: 'indeferido',
      color: 'black',
      type: 'factors',
      location: 'head',
      setLabel: function (newLabel) {
        this.label = newLabel
        this.color = _self.getDotColor(this.label)
      }
    }

    treatMetrics['Risco de desenvolver Doença do Coração'] = {
      validate(param) {
        return ( param.result.kit_type.tag_type == "check-up-saude-do-coracao"
                 || param.result.kit_type.tag_type == "check-up-longevidade-saudavel"
                 || (param.result.kit_type.tag_type == "check-up-saude-preventiva" && !param.hasHeartDisease) )
             && !param.hasHeartDisease
      },
      code: 'risco_coracao',
      title: 'Doenças do coração',
      altTitle: 'coracao',
      name: 'Fatores Preliminares para Desenvolver Doenças do Coração',
      label: 'indeferido',
      color: 'black',
      type: 'factors',
      location: 'torso',
      setLabel: function (newLabel) {
        this.label = newLabel
        this.color = _self.getDotColor(this.label)
      }
    }

    treatMetrics['Risco de desenvolver Osteoporose'] = {
      validate(param) {
        return ( param.result.kit_type.tag_type == "check-up-longevidade-saudavel"
                || param.result.kit_type.tag_type == "check-up-saude-preventiva" ) && !param.hasOsteoporosis
      },
      code: 'risco_osteoporose',
      title: 'Osteoporose',
      altTitle: 'osteoporose',
      name: 'Fatores Preliminares para Desenvolver Osteoporose',
      label: 'indeferido',
      color: 'black',
      type: 'factors',
      location: 'leg',
      setLabel: function (newLabel) {
        this.label = newLabel
        this.color = _self.getDotColor(this.label)
      }
    }

    treatMetrics['Risco de desenvolver Dislipidemia'] = {
      validate(param) {
        return ( param.result.kit_type.tag_type == "check-up-saude-do-coracao"
                 || param.result.kit_type.tag_type == "check-up-doencas-cronicas"
                 || param.result.kit_type.tag_type == "check-up-saude-preventiva" )
      },
      code: 'risco_dislipidemia',
      title: 'Dislipidemia',
      altTitle: 'dislipidemia',
      name: 'Fatores Preliminares para Desenvolver Dislipidemia',
      label: 'indeferido',
      color: 'black',
      type: 'factors',
      location: 'torso',
      setLabel: function (newLabel) {
        this.label = newLabel
        this.color = _self.getDotColor(this.label)
      }
    }

    treatMetrics['Risco de desenvolver Síndrome Metabólica'] = {
      validate(param) {
        return ( param.result.kit_type.tag_type == "check-up-saude-do-coracao"
                 || param.result.kit_type.tag_type == "check-up-doencas-cronicas"
                 || param.result.kit_type.tag_type == "check-up-longevidade-saudavel"
                 || param.result.kit_type.tag_type == "check-up-saude-preventiva" )
      },
      code: 'risco_metabolica',
      title: 'Síndrome Metabólica',
      altTitle: 'metabolica',
      name: 'Fatores Preliminares para Desenvolver Síndrome Metabólica',
      label: 'indeferido',
      color: 'black',
      type: 'factors',
      location: 'abdomen',
      setLabel: function (newLabel) {
        this.label = newLabel
        this.color = _self.getDotColor(this.label)
      }
    }

    treatMetrics['Risco Doenca Renal'] = {
      validate(param) {
        return (param.result.kit_type.tag_type == "check-up-saude-preventiva")
      },
      code: 'risco_renal',
      title: 'Doença Renal Crônica',
      altTitle: 'renal',
      name: 'Fatores Preliminares para Desenvolver Doença Renal Crônica',
      label: 'indeferido',
      color: 'black',
      type: 'factors',
      location: 'abdomen',
      setLabel: function (newLabel) {
        this.label = newLabel
        this.color = _self.getDotColor(this.label)
      }
    }

    if (!!this.result && !!this.result.customer && !!this.result.customer.updated_metrics) {
      this.metrics.forEach(metric => {
        const treat = _.get(treatMetrics, metric.risk.name, null)
        if ( treat && treat.validate(this)) {
          if (metric.ticket.label)
            treat.setLabel(metric.ticket.label)
          this[treat.type].push(treat)
        }
      });
    }
    this.$forceUpdate();
    
    this.firstPanel = !(window.screen.width <= 1000);

    this.headItems.risks = this.risks.filter(risk => risk.location == 'head');
    this.headItems.factors = this.factors.filter(factor => factor.location == 'head');
    this.torsoItems.risks = this.risks.filter(risk => risk.location == 'torso');
    this.torsoItems.factors = this.factors.filter(factor => factor.location == 'torso');
    this.abdomenItems.diagnostics = this.diagnostics.filter(risk => risk.location == 'abdomen');
    this.abdomenItems.risks = this.risks.filter(risk => risk.location == 'abdomen');
    this.abdomenItems.factors = this.factors.filter(factor => factor.location == 'abdomen');
    this.pelvisItems.risks = this.risks.filter(risk => risk.location == 'pelvis');
    this.pelvisItems.factors = this.factors.filter(factor => factor.location == 'pelvis');
    this.legItems.risks = this.risks.filter(risk => risk.location == 'leg');
    this.legItems.factors = this.factors.filter(factor => factor.location == 'leg');
    this.outItems.risks = this.risks.filter(risk => risk.location == 'out');
    this.outItems.factors = this.factors.filter(factor => factor.location == 'out');

    this.prevention['1'] = [];
    this.prevention['3'] = [];
    this.prevention['6'] = [];
    this.prevention['12'] = [];
    this.prevention['24'] = [];
    this.prevention['25'] = [];
    this.getUserExams();
  },
}
</script>
<style scoped>
@import "./kit-risks.scss";
@import "./responsive.css";

.risk-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: 100%;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.risk-header .button {
  font-size: 15px;
  margin-bottom: 15px;
}

.risk-header .button:not(:last-child) {
  margin-right: 15px;
}

.dot-blue {
  color: var(--blue);
}

.dot-green {
  color: var(--green);
}

.dot-red {
  color: var(--red);
}

.dot-yellow {
  color: var(--yellow);
}

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateY(10px);
  opacity: 0;
}

.font-weight-bold {
  font-weight: bold;
}

.btn-light-blue {
  background: var(--blue);
}

.half-title {
  color: #203298;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

.btn-margin {
  white-space: nowrap;
  width: 150px;
  margin-left: 5px;
  margin-right: 5px;
}
.avatar-and-risks {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/components/KitRisks/KitRisks.vue